import React from 'react';
import { compose, contains, equals } from 'ramda';
import { isImmutable } from 'immutable';
import Select from 'react-select';
import RichText from '@synergycms_core/components/generic/RichText';
import styleFile from './SelectField.js';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withForm } from './';

const customStyle = {
  dropdownIndicator: (base, state) => ({
    ...base,
    transition: "all .2s ease",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
    cursor: "pointer"
  })
};

export default compose(
  withForm(),
  PropertyManager([
    'form',
    'formModel',
    'validations',
    'model',
    'css',
    'validationsFields',
    //REACT-SELECT props
    'autoFocus',
    'components',
    'onValueChange',
    'focus',
    'onBlur',
    'onChange',
    'isDisabled',
    'defaultValue',
    'getOptionLabel',
    'getOptionValue',
    'isMulti',
    'isSearchable',
    'name',
    'options',
    'placeholder',
    'value',
    'styles',
    'label',
    'selectedOnchangeList',
    'verifyInListSelected',
    'isMenuOpen',
  ]),
  withThemeJSS({ styleFile })
)(
  class SelectField extends React.Component {
    static displayName = 'SelectField';
    constructor(props) {
      super(props);
      this.selectRef = React.createRef();
      const { form, model, defaultValue = '', validations = [], validationsFields, label = '' } = this.props.config;

      form.subscribe({
        onChange: this.onChange,
        forceUpdate: this.forceUpdate,
        value: defaultValue,
        validationsFields,
        defaultValue,
        validations,
        model,
        label
      });

      this.state = {
        value: defaultValue,
        menuIsOpen: false,
        inputValue: defaultValue,
      };
    }

    componentWillReceiveProps = (nextProp, prevState) => {
      if (nextProp.config.verifyInListSelected && nextProp.config.options !== this.props.config.options) {
        let newVal;
        const newList= nextProp.config.options;
        const oldVal = this.state.value;
        if(isImmutable(newList)){
          newVal = newList.find((value)=> value === oldVal) || newList.get(0);
        } else {
          newVal = contains(oldVal, newList) ? oldVal : newList[0];
        }
      
        newVal && this.onChange(newVal, true);
      }
    };

    componentWillUnmount() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      const { form, model } = this.props.config;
      
      form.unSubscribe({ model: model });
      window.removeEventListener('wheel', this.handleScroll, true);
    }

    /*
    componentWillReceiveProps(nextProps) {
      const { options: nextSelectorData, selectedOnchangeList } = nextProps.config;
      const { value } = this.state;

      if(selectedOnchangeList) {
        const newValue = selectedOnchangeList(newList, currentValue);

        if(!reducedNextOptions) {
          this.onChange(newValue, true);
        }
      }
    }*/

    componentDidMount = () => {
      window.addEventListener('wheel', this.handleScroll, true);
    };

    handleScroll = (event) => {
      if (!this.selectRef.current?.select?.menuListRef?.contains(event.target)) {
        this.setState({ menuIsOpen: false });
      }
    };

    handleMenuOpen = () => {
      this.setState({ menuIsOpen: true });
    };

    handleMenuClose = () => {
      this.setState({ menuIsOpen: false });
      
      const { options, getOptionLabel } = this.props.config;
      const matchedOption = options.find(option => getOptionLabel(option) === this.state.inputValue);
      if (matchedOption) this.onChange(matchedOption, false);
    };

    onChange = (selected, preventCallback) => {
      if (selected) {
        this.setState({ value: selected }, () => {
          if (this.props.config.formModel) {
            const { config } = this.props;
            const { validations } = config.formModel;
            config.form.onGlobalChange(config.model, selected, preventCallback).then(() => {
              config.form.onGlobalBlur(config.model, validations, selected, preventCallback);
            });
          }
        });
      }
    };

    handleInputChange = (inputValue) => {
      this.setState({ inputValue: inputValue });
    };

    render = () => {
      const { theme, config } = this.props;
      const {
        form,
        formModel,
        placeHolder,
        model,
        css,
        options,
        components,
        getOptionLabel,
        getOptionValue,
        defaultValue,
        styles = {},
        isSearchable
      } = config;

      const combinedStyles = {
        ...styles,
        dropdownIndicator: (base, state) => ({
            cursor:'pointer',
          ...base,
          ...(styles.dropdownIndicator ? styles.dropdownIndicator(base, state) : {}),
          ...customStyle.dropdownIndicator(base, state),
          color: theme.themeValues.mainColor,
          '&:hover': {
            color: theme.themeValues.mainColor
          }
        })
      };

      return (
        (formModel && (
          <Select
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            isSearchable={isSearchable}
            className={[form.getValidClass(formModel, css, theme), theme.computedInnerStyle].join(' ')}
            onChange={this.onChange}
            styles={combinedStyles}
            defaultValue={defaultValue}
            value={formModel.value}
            components={components}
            options={options}
            name={model}
            placeholder={placeHolder}
            ref={this.selectRef}
            menuIsOpen={this.state.menuIsOpen} // Controla el estado del menú
            onMenuOpen={this.handleMenuOpen} // Evento para abrir el menú
            onMenuClose={this.handleMenuClose} // Evento para cerrar el menú
            classNamePrefix="select"
            onInputChange={this.handleInputChange} // Handle search input change
            noOptionsMessage={() => <RichText text={"_%sin opciones%_"} innerStyle={'roboto13Black'} translate={true} ucFirst={true} />}
          />
        )) ||
        null
      );
    };
  }
);
